import React, { useState, useEffect } from "react";
import { SubscriptionService } from "../../services/subscription_service";
import Notification from "../../components/Notification/Notification";
import styles from "./Subscription.module.css";
import { useSubscriptionState } from "../../states/useSubscriptionState";

const Subscription = () => {
  const subscriptionService = SubscriptionService();

  const {subscriptionList, setSubscriptionList,
        formData, setFormData, errors, setErrors, submitting, setSubmitting, notification, setNotification} = useSubscriptionState();

  // Fetch existing subscriptions on load
  useEffect(() => {
    subscriptionService.fetchSubscription(setSubscriptionList);
  }, []);

  // Auto-hide notification
  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setNotification(prev => ({ ...prev, show: false }));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification.show]);

  // 🔹 Email validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🔹 Email already exist check (FRONTEND)
  const isEmailAlreadySubscribed = (email) => {
    return subscriptionList.some(
      sub => sub.email?.toLowerCase() === email.toLowerCase()
    );
  };

  const handleChange = (e) => {
    setFormData({ email: e.target.value });

    if (errors.email) {
      setErrors({});
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // EMAIL ALREADY EXISTS
    if (isEmailAlreadySubscribed(formData.email)) {
      setErrors({ email: "This email is already subscribed." });
      // setNotification({
      //   show: true,
      //   type: "warning",
      //   title: "Already Subscribed",
      //   message: "This email is already subscribed."
      // });
      return;
    }

    setSubmitting(true);

    const success = await subscriptionService.createSubscription(
      formData,
      setSubscriptionList,
      setErrors
    );

    setSubmitting(false);

    if (success) {
      setNotification({
        show: true,
        type: "success",
        title: "Subscription Successful!",
        message: "Thank you for subscribing."
      });

      setFormData({ email: "" });
      setErrors({});
    } else {
      setNotification({
        show: true,
        type: "error",
        title: "Subscription Failed",
        message: "Failed to subscribe. Please try again."
      });
    }
  };

  return (
    <>
      <Notification
        show={notification.show}
        type={notification.type}
        title={notification.title}
        message={notification.message}
        onClose={() => setNotification(prev => ({ ...prev, show: false }))}
      />

      <section className={styles.ctaSection}>
        <div className={styles.container}>
          <div className={styles.ctaContent}>
            <h2>Never Miss an Event!</h2>
            <p className={styles.p}>
              Subscribe to get notifications about upcoming events and offers.
            </p>

            <form onSubmit={handleSubmit} noValidate className={styles.form}>
              <div className={styles.ctaForm}>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  placeholder="Enter your email"
                  onChange={handleChange}
                  disabled={submitting}
                  className={`${styles.emailInput} ${
                    errors.email ? styles.errorInput : ""
                  }`}
                />
                {errors.email && (
                <div className={styles.errorMessage}>
                 <strong style={{fontWeight : "500"}}> {errors.email}</strong>
                </div>
              )}

              </div>
                <button
                  type="submit"
                  className={styles.ctaButton}
                  disabled={submitting}
                >
                  {submitting ? "Subscribing..." : "Subscribe"}
                </button>

              
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Subscription;
